<template>
  <div class="recommend-blog-item">
    <img alt="" uk-img width="300" height="300" :data-src="blog.blog_img_read_more_pc" />
    <div class="blog-info">
      <div class="category">{{ categoryStr}}</div>
      <div class="title">{{ blog.title }}</div>
      <div class="description">{{ blog.description }}</div>
    </div>
    <a :href=blogUrl style="display:block;position:absolute; top:0;height:100%; width:100%; text-decoration:none"></a>
  </div>
</template>
<script>
export default {
  name: "RecommendBlogItem",
  props: ["blog"],
  computed: {
    blogUrl() {
      return "/blog/" + this.blog.slug_name;
    },
    categoryStr() {
      if (this.blog.category === 'SEEDS') {
        return '人物專訪'
      }else if (this.blog.category === 'FICTION') {
        return '短篇小說'
      }else if (this.blog.category === 'FEEDBACK') {
        return '學員故事'
      }else if (this.blog.category === 'INFORMATION') {
        return '知識文章' 
      }else {
        return ''
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.recommend-blog-item {
  border-bottom: solid 0.5px #106772;
  position: relative;
  padding: 20px 0;
  img {
    width: 100%;
    height: auto;
  }
  .blog-info {
    .category {
      font-family:  'Heebo', 'Noto Sans TC', sans-serif;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: 0.56px;
      text-align: left;
      color: #106772;
      padding: 0 0 12px;
    }
    .title {
      font-family:  'Heebo', 'Noto Sans TC', sans-serif;
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.65;
      letter-spacing: 0.8px;
      text-align: left;
      color: #585858;
      padding: 0 0 18px;
    }
    .description {
      font-family:  'Heebo', 'Noto Sans TC', sans-serif;
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.81;
      letter-spacing: normal;
      text-align: left;
      color: #b5b5b5;
      max-height: calc(1.72em * 3);
      overflow: hidden;
    }
    padding: 20px 0 0;
  }
  @media (min-width: 640px) and (max-width: 1119.98px) {
    padding: 36px 0;
    img {
      display: inline-block;
      max-width: 235px;
    }
    .blog-info {
      max-width: calc(100vw - 245px - 33px - 60px);
      .category {
        font-size: 14px;
        letter-spacing: 0.56px;
        padding: 0 0 12px;
      }
      .title {
        font-size: 20px;
        line-height: normal;
        letter-spacing: normal;
        padding: 0 0 16px;
      }
      .description {
        font-size: 16px;
        font-weight: normal;
        line-height: 1.81;
        letter-spacing: normal;
        max-height: calc(1.72em * 2);
        padding: 0;
        overflow: hidden;
      }
      vertical-align: top;
      display: inline-block;
      padding: 0 0 0 33px;
    }
  }
  @media (min-width: 1120px) {
    padding: 32px 0;

    img {
      display: inline-block;
      max-width: 245px;
    }
    .blog-info {
      max-width: calc(1120px - 245px - 60px);
        @media (min-width: 1280px) {
          max-width: calc(1080px - 245px - 60px);
        }
      .category {
        font-size: 14px;
        letter-spacing: 0.56px;
        padding: 0 0 16px;
      }
      .title {
        font-size: 20px;
        font-weight: bold;
        line-height: normal;
        letter-spacing: normal;
        padding: 0 0 16px;
      }
      .description {
        font-size: 16px;
        line-height: 1.81;
        letter-spacing: normal;
        overflow: hidden;
        max-height: calc(1.72em * 2);
        padding: 0;
      }
      display: inline-block;
      vertical-align: top;
      padding: 0 0 0 60px;
    }
  }
}
</style>